import {DocumentGeneratorDevice} from "@app/models/automation/documentgenerator/documentGeneratorDevice";
import {Discipline} from "@app/models/shared/discipline.enum";

export class DocumentGeneratorProcessRequest {
  documentGeneratorIds: number[];
  devices: DocumentGeneratorDevice[];
  selectedDiscipline: Discipline;
}
